export default __webpack_public_path__ + "static/media/P-045.24f3ecee.png";